import { FC, useEffect, useState } from "react";
import { BiRefresh, BiPlusCircle } from "react-icons/bi";
import { floatToPrice } from "../../functions/price_functions";
import { useOrder } from "../../hooks/useOrder";
import InputMask from "react-input-mask";
import { useAppConfig } from "../../hooks/useAppConfig";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import "./index.css";
import api from "../../services/api";
import {
  CustomerType,
  DeliveryAddressType,
  MeasureType,
  OrderType,
  ProductType,
} from "../../contexts/OrderContext";
import {
  cepNoMask,
  cepToMask,
  cpfCnpjNoMask,
  telephoneNoMask,
} from "../../functions/mask";
import Swal from "sweetalert2";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useNavigate, useParams } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import { address } from "../Perfil/addresses/addressesIndex";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { ModalSelectAddress } from "../../components/ModalSelectAddress";
import { ModalCreateAddress } from "../../components/ModalCreateAddress";
import { NewCartItem } from "../../components/newCartItem/cartItem";

type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures?: MeasureType;
  }>;
};

type StoresType = {
  id: number;
  name: string;
  city: string;
  district: string;
  street: string;
  number: string;
  currentBalance: number;
  distance: string;
  locationId?: number;
  sku?: string;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationType = {
  id: number;
  name: string;
  code: string;
  status: boolean;
  type: string;
  cep: string;
  address: AddressLocationType | null;
};

type PluginconfigType = {
  id: number;
  pluginspaceId: number;
  plugintypeId: number;
  plugintemplateId: {
    id: number;
    name: string;
  };
  name: string;
  content: any;
};

type ProductTotvsType = {
  id: number;
  chair: string;
  image: string;
  stock: number;
  codFilial: string | null;
  code: string;
  discount: number;
  productName: string;
  hash: string;
  info: string;
  notes: string;
  price: number;
  productSku: string;
  quantity: number;
  unitPrice: number;
  locationId: number;
  variation: Array<{
    grid: string;
    value: string;
  }>;
};
type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

const NewCartLogin: FC = () => {
  const navigate = useNavigate();
  const orderContext = useOrder();
  const {
    changeCustomerAdress,
    setType,
    setOrderAddress,
    setLocationId,
    changeAddressDelivery,
    setCustomer,
  } = useOrder();
  const { pluginspace_id } = useParams();
  const {
    getToken,
    pluginspaceData,
    registerAccess,
    getThisPluginspace,
    getLocations,
  } = usePluginspace();
  const [cep, setCep] = useState("");
  const [cepAlarm, setCepAlarm] = useState(false);
  const [findCep, setFindCep] = useState(false);
  const [freightFind, setFreightFind] = useState(0);
  const [typeFreight, setTypeFreight] = useState("withdraw");
  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);

  const [valueCep, setValueCep] = useState(0);
  const [stores, setStores] = useState<Array<StoresType>>([]);
  const [productStores, setProductStores] = useState<Array<StoresType>>([]);
  const [locations, setLocations] = useState<Array<LocationType>>([]);

  const [order, setOrder] = useState<OrderType>();
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);

  const [hideMenu, setHideMenu] = useState(false);

  const [coupon, setCoupon] = useState("");
  const [totvsVarejoAble, setTotvsVarejoAble] = useState(false);
  const [totvsMotorAble, setTotvsMotorAble] = useState(false);
  const [typePluginspace, setTypePluginspace] = useState("");

  const [valueWithDraw, setValueWithDraw] = useState(0);

  const [minimumValue, setMinimumValue] = useState(0);

  const [validShift, setValidShift] = useState(true);

  //Se está logado ou não
  const [login, setLogin] = useState(false);
  const [canWithdraw, setCanWithdraw] = useState(false);

  //Login Infos
  const { loginInfo } = useAuth();
  const [addresses, setAddresses] = useState<address[]>([]);
  const [address, setAddress] = useState<address>({
    id: 0,
    customerId: 0,
    typeAddress: "",
    street: "",
    number: "",
    district: "",
    complement: "",
    city: "",
    state: "",
    extra: "",
    zipCode: "",
    ibgeCode: "",
  });

  //SearchAddress
  const [searchAddress, setSearchAddress] = useState<address>({
    id: 0,
    customerId: 0,
    typeAddress: "",
    street: "",
    number: "",
    district: "",
    complement: "",
    city: "",
    extra: "",
    state: "",
    zipCode: "",
    ibgeCode: "",
  });

  const [customerName, setCustomerName] = useState<string>("");
  const [customerPhone, setCustomerPhone] = useState<string>("");

  //modal de criar e selecionar address
  const [createAddressOpen, setCreateAddressOpen] = useState(false);
  const [selectAddressOpen, setSelectAddressOpen] = useState(false);

  async function findCustomer(cpfOrCnpj: string) {
    const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);

    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerAddresses = response.data.data[0].customerAddresses;
          orderContext.changeCustomerDocument(cpfOrCnpj);
          if (customerAddresses.length > 0) {
            setCep(customerAddresses[0].zipCode);
            orderContext.changeCustomerAdress(customerAddresses[0].zipCode);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadAll() {
    setLoading(true);
    await getVerifyShift();
    await verifyTotvs();
    await loadAddresses();
    await getConfig();
    await loadOrder();

    const loc = await getLocations();

    setLocations(loc);

    const pgData = await getThisPluginspace();
    if (pgData && pgData.type) {
      setTypePluginspace(pgData.type);
    }

    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);

      const documento = await orderContext.getCustomerDocument();
      if (documento) await findCustomer(documento);
    }

    loginInfo.accessToken !== "" ? setLogin(true) : setLogin(false);
    setLoading(false);
  }

  async function verifyTotvs() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 15,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];

          if (configData.content.able === "1") {
            setTotvsVarejoAble(true);
            if (configData.content.habilitarMotorPromocao === "1") {
              setTotvsMotorAble(true);
              if (orderContext.order) {
                const productsCart: ProductType[] =
                  orderContext.order?.products.map((product) => {
                    product.promotionalPrice = product.unitPrice;
                    return product;
                  });
                setOrder({
                  products: productsCart,
                });
                await orderContext.changeOrderByGuidCart(
                  productsCart,
                  orderContext
                );
              }
              orderContext.setDiscountGeneral(0);
              await orderContext.totalValueOrder();
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadOrder() {
    const newOrder = await orderContext.getOrder();
    const totalValues = await orderContext.totalValueOrder();
    setTotal(totalValues.total);
    setTotalWithoutDiscount(totalValues.totalWithoutDiscount);
    setOrder(newOrder);
  }

  // Função que retorna o carrinho do cliente (Criado pelo vendedor)
  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const order = response.data.data[0];
        if (
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].cpfSeller
        ) {
          orderContext.setSellerCpfCnpj(response.data.data[0].cpfSeller);
        }
        orderContext.setCustomer({
          name: order.customerName,
          telephone: order.phoneCustomer,
          cpf: order.cpfCustomer,
        });

        orderContext.setGuidCart(guid);

        orderContext.changeCustomerDocument(order.cpfCustomer);

        let productsCart: any = [];

        if (order.jsonCart.products) {
          productsCart = order.jsonCart.products.map(
            (product: ProductCartType) => {
              const variationFormated: any = {};
              product.variation.map((variation: any) => {
                variationFormated[variation.grid] = variation.value
                  ? variation.value
                  : variation.valor;

                return;
              });
              const newProduct: ProductType = {
                id: product.id,
                image: product.img,
                code: product.code,
                locationId: order.locationId,
                name: product.name,
                promotionalPrice: product.promotional_price,
                quantity: product.quantity,
                sku: product.sku,
                stock: product.sku_info[0].inventory,
                unitPrice: product.unitPrice,
                variation: variationFormated,
                pluginspaceHash: pluginspace_id ? pluginspace_id : "",
                outStock: false,
                measures: product.sku_info[0].measures
                  ? product.sku_info[0].measures
                  : null,
              };
              return newProduct;
            }
          );
        } else {
          productsCart = order.jsonCart.map((product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;

              return;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: order.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          });
        }

        setOrder({
          products: productsCart,
        });
        await orderContext.changeOrderByGuidCart(productsCart, orderContext);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getConfig() {
    const config = await getAppConfig();
    setMinimumValue(config!.content.pdv.minimumValue);

    setConfig(config);

    if (config) {
      const value = config!.content.pdv.withDrawFee
        ? parseFloat(config!.content.pdv.withDrawFee.toString())
        : 0;

      setValueWithDraw(value);
      setFreightFind(value);
    }
  }

  async function chooseAddress() {
    const locationType = locations.find((loc) => typeFreight === loc.code);
    if (locationType && !(config && config.content.pdv.showOutStock)) {
      let success = true;
      const orderSave = await orderContext.getOrder();
      await api
        .post(
          `/api/variations/sku-inventory`,
          {
            skus:
              orderSave && orderSave.products
                ? orderSave.products.map((p) => p.sku)
                : [],
            locationId: locationType.id,
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.success && response.data.data) {
            const itemsSku = response.data.data.filter(
              (product: any) => product.inventory <= 0
            );
            if (itemsSku.length > 0) {
              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: `Produtos: ${itemsSku
                  .map((u: any) => u.name)
                  .join(", ")} sem estoque`,
              });
              success = false;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Falha ao recuperar estoque de produtos`,
            });
            success = false;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: `Falha ao recuperar estoque de produtos`,
          });
          success = false;
        });
      if (!success) return;
    }

    orderContext.setFreight(freightFind);

    if (typeFreight === "delivery") {
      orderDelivery();
    } else {
      orderWithDraw();
    }
  }

  async function findCepDelivery() {
    const noMaskCep = cepNoMask(cep);

    if (config) {
      const value = config!.content.pdv.withDrawFee
        ? parseFloat(config!.content.pdv.withDrawFee.toString())
        : 0;

      setValueWithDraw(value);
      setFreightFind(value);
    }
    setLoading(true);
    let urlSearchValid = "";
    switch (config?.content.pdv.restrictCep) {
      case "cep":
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
      case "area":
        urlSearchValid = `/api/delivery/valid/${noMaskCep}`;
        break;
      case "mapa":
        urlSearchValid = `/api/delivery-area/valid/${noMaskCep}`;
        break;
      default:
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
    }
    await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const findedCeps = response.data.data;

        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);
          setValueCep(findedCeps[0].valor);
        } else {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Não foi possível encontrar formas de envio para o CEP",
          });

          setFindCep(false);
          setCanWithdraw(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        setFindCep(false);
        setCanWithdraw(false);
        console.log(err);
        setLoading(false);
      });
  }

  async function validCep(cep: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          return false;
        }
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  function validatePurchaseMin() {
    return total >= minimumValue ? true : false;
  }

  //Nessa Função ocorre a validação do cep e depois a busca pra saber se é valido ou não para a loja
  async function getStores() {
    setLoading(true);

    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      setLoading(false);
      setTimeout(function () {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
            minimumValue
          )}`,
        });
      }, 10);
      return;
    }

    const cepOk = await validCep(cep);
    if (!cepOk) {
      setLoading(false);
      Swal.fire({
        icon: "warning",
        title: "CEP inválido!",
        text: "Verifique se o CEP foi digitado corretamente",
      });
      return;
    }
    const noMaskCep = cepNoMask(cep);
    const orderSave = await orderContext.getOrder();

    const skus: Array<String> | undefined = orderSave.products.map(
      (prod) => prod.sku
    );
    const pgData = await getThisPluginspace();

    /*
            variavel para verificar se ha a necessidade de pesquisar novamente os 
            estoques do produto. Funciona somente se a pluginSpace for FOOD
    	
        */

    const orderBackUp = await orderContext.getOrderToVerify();

    if (orderBackUp) {
      let shouldSearchAgain = false;
      const skusToVerify: Array<String> | undefined = [];
      const prodsToVerify: Array<ProductType> | undefined = [];

      orderSave.products.map((produto) => {
        const productVerify = orderBackUp.products.find(
          (prod) => prod.sku === produto.sku
        );

        if (productVerify) {
          if (produto.quantity > productVerify.quantity) {
            shouldSearchAgain = true;
            skusToVerify.push(produto.sku);
            prodsToVerify.push(produto);
          }
        } else {
          skusToVerify.push(produto.sku);
          prodsToVerify.push(produto);
          shouldSearchAgain = true;
        }
      });

      if (shouldSearchAgain) {
        await api
          .post(
            `/api/variations/skuzipcode`,
            {
              zipcode: noMaskCep,
              skus: skusToVerify ? skusToVerify : [],
              restrictCep: config?.content.pdv.restrictCep
                ? config?.content.pdv.restrictCep
                : "cep",
              noVerifyStock:
                config && config.content.pdv.showOutStock ? true : false,
              locationId: locations.find((el) => el.type == "internal")?.id
                ? locations.find((el) => el.type == "internal")?.id
                : null,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          )
          .then(async (response) => {
            let newStores: Array<StoresType> = [];

            if (!response.data || response.data.success === false) {
              setLoading(false);
              //Fazer um for para mostrar todos os produtos e mostrar na tela
              if (response.data.dataEmpty) {
                const ids = response.data.dataEmpty.map(
                  (prod: any) => prod.sku
                );
                const filtered = response.data.dataEmpty.filter(
                  (prod: any, index: number) =>
                    !ids.includes(prod.sku, index + 1)
                );

                Swal.fire({
                  icon: "warning",
                  title: response.data.message
                    ? response.data.message
                    : "CEP indisponível!",
                  text:
                    response.data.dataEmpty &&
                    response.data.dataEmpty.length > 0
                      ? `Produtos: ${filtered
                          .map((u: any) => u.name)
                          .join(", ")} sem estoque`
                      : "",
                });
              } else {
                const filtered: any = [];
                Swal.fire({
                  icon: "warning",
                  title: response.data.message
                    ? response.data.message
                    : "CEP indisponível!",
                  text:
                    response.data.dataEmpty &&
                    response.data.dataEmpty.length > 0
                      ? `Produtos: ${filtered
                          .map((u: any) => u.name)
                          .join(", ")} sem estoque`
                      : "Produtos não disponiveis!",
                });
              }

              setCanWithdraw(false);
              setStores([]);
              setFindCep(false);
              return;
            }
            //Fazer validação dos produtos desativados no retorno ;

            // comparar sku enviado com os retornados.
            const ids = response.data.map((prod: any) => prod.sku);
            const filtered = response.data.filter(
              (prod: any, index: number) => !ids.includes(prod.sku, index + 1)
            );
            let doesNotexists = skusToVerify.map((skus: any) => {
              const find = filtered.find((prod: any) => prod.sku === skus);

              if (!find) {
                return skus;
              }
            });

            doesNotexists = doesNotexists.filter(
              (skus: any) => skus !== undefined
            );

            if (doesNotexists.length > 0) {
              const produtos = doesNotexists.map((skus: any) => {
                const find = orderSave.products.find(
                  (prod: any) => prod.sku === skus
                );

                return find!.name;
              });

              setLoading(false);
              Swal.fire({
                icon: "warning",
                title: response.data.message
                  ? response.data.message
                  : "Produtos Indisponiveis!",
                text: `Produtos: ${produtos
                  .map((u: any) => u)
                  .join(", ")} não disponiveis`,
              });
              setCanWithdraw(false);
              setStores([]);
              setFindCep(false);
              return;
            }

            setProductStores(response.data);
            response.data.map((str: StoresType) => {
              const newStore = {
                id: str.id,
                name: str.name,
                city: str.city,
                district: str.district,
                street: str.street,
                number: str.number,
                distance: str.distance,
                currentBalance: str.currentBalance,
              };
              const findedStore = newStores.find(
                (findStore) =>
                  findStore.name === newStore.name &&
                  findStore.distance === newStore.distance
              );
              if (!findedStore) {
                newStores.push(newStore);
                localStorage.setItem("storeAddress", JSON.stringify(newStore));
              }
            });
            setCanWithdraw(true);
            await findCepAdress(noMaskCep);
            await findCepDelivery();

            setStores(newStores);
            setLoading(false);

            orderContext.setOrderToVerify(orderSave);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "Erro!",
              text: "Falha ao buscar CEP",
            });
          });
      } else {
        //verificação la loja, para adicionar como opção
        const localStore = localStorage.getItem("storeAddress");

        if (localStore) {
          const locations = JSON.parse(localStore);

          setStores([locations]);
        }

        setCanWithdraw(true);
        await findCepAdress(noMaskCep);
        await findCepDelivery();
        setLoading(false);
      }
    } else {
      await api
        .post(
          `/api/variations/skuzipcode`,
          {
            zipcode: noMaskCep,
            skus: skus ? skus : [],
            restrictCep: config?.content.pdv.restrictCep
              ? config?.content.pdv.restrictCep
              : "cep",
            noVerifyStock:
              config && config.content.pdv.showOutStock ? true : false,
            locationId: locations.find((el) => el.type == "internal")?.id
              ? locations.find((el) => el.type == "internal")?.id
              : null,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          let newStores: Array<StoresType> = [];

          if (!response.data || response.data.success === false) {
            setLoading(false);
            //Fazer um for para mostrar todos os produtos e mostrar na tela
            if (response.data.dataEmpty) {
              const ids = response.data.dataEmpty.map((prod: any) => prod.sku);
              const filtered = response.data.dataEmpty.filter(
                (prod: any, index: number) => !ids.includes(prod.sku, index + 1)
              );

              Swal.fire({
                icon: "warning",
                title: response.data.message
                  ? response.data.message
                  : "CEP indisponível!",
                text:
                  response.data.dataEmpty && response.data.dataEmpty.length > 0
                    ? `Produtos: ${filtered
                        .map((u: any) => u.name)
                        .join(", ")} sem estoque`
                    : "",
              });
            } else {
              const filtered: any = [];
              Swal.fire({
                icon: "warning",
                title: response.data.message
                  ? response.data.message
                  : "CEP indisponível!",
                text:
                  response.data.dataEmpty && response.data.dataEmpty.length > 0
                    ? `Produtos: ${filtered
                        .map((u: any) => u.name)
                        .join(", ")} sem estoque`
                    : "Produtos não disponiveis!",
              });
            }

            setCanWithdraw(false);
            setStores([]);
            setFindCep(false);
            return;
          }
          //Fazer validação dos produtos desativados no retorno ;

          // comparar sku enviado com os retornados.
          const ids = response.data.map((prod: any) => prod.sku);
          const filtered = response.data.filter(
            (prod: any, index: number) => !ids.includes(prod.sku, index + 1)
          );
          let doesNotexists = skus.map((skus: any) => {
            const find = filtered.find((prod: any) => prod.sku === skus);

            if (!find) {
              return skus;
            }
          });

          doesNotexists = doesNotexists.filter(
            (skus: any) => skus !== undefined
          );

          if (doesNotexists.length > 0) {
            const produtos = doesNotexists.map((skus: any) => {
              const find = orderSave.products.find(
                (prod: any) => prod.sku === skus
              );

              return find!.name;
            });

            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: response.data.message
                ? response.data.message
                : "Produtos Indisponiveis!",
              text: `Produtos: ${produtos
                .map((u: any) => u)
                .join(", ")} não disponiveis`,
            });
            setCanWithdraw(false);
            setStores([]);
            setFindCep(false);
            return;
          }

          setProductStores(response.data);
          response.data.map((str: StoresType) => {
            const newStore = {
              id: str.id,
              name: str.name,
              city: str.city,
              district: str.district,
              street: str.street,
              number: str.number,
              distance: str.distance,
              currentBalance: str.currentBalance,
            };
            const findedStore = newStores.find(
              (findStore) =>
                findStore.name === newStore.name &&
                findStore.distance === newStore.distance
            );
            if (!findedStore) {
              localStorage.setItem("storeAddress", JSON.stringify(newStore));
              newStores.push(newStore);
            }
          });
          setCanWithdraw(true);
          await findCepAdress(noMaskCep);
          await findCepDelivery();

          setStores(newStores);
          setLoading(false);

          orderContext.setOrderToVerify(orderSave);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: "Erro!",
            text: "Falha ao buscar CEP",
          });
        });
    }
  }

  async function calculateDiscount() {
    if (totvsVarejoAble) {
      setLoading(true);
      const products = order?.products.map((product) => ({
        hash: window.btoa(product.code),
        id: product.id,
        productName: product.name,
        image: product.image,
        stock: product.stock,
        code: product.code,
        locationId: product.locationId,
        quantity: product.quantity,
        discount:
          product.promotionalPrice !== product.unitPrice &&
          product.promotionalPrice !== 0
            ? parseInt(
                ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                  0
                )
              )
            : 0,
        price:
          product.promotionalPrice !== product.unitPrice &&
          product.promotionalPrice !== 0
            ? parseInt(
                ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                  0
                )
              )
            : parseInt((product.unitPrice * 100).toFixed(0)),
        unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
        codFilial: pluginspaceData?.id,
        info: "",
        chair: "",
        notes: "",
        productSku: product.sku,
        variation: Object.entries(product.variation).map((obj) => ({
          grid: obj[0],
          value: obj[1],
        })),
      }));
      await api
        .post(
          "/api/totvsPromotionEngine/calculatePromotion",
          {
            "couponPromotionalCode--": coupon,
            discountGeneral: 0.0,
            products,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setLoading(false);
          if (response.data) {
            const newProducts: Array<ProductType> = response.data.products.map(
              (product: ProductTotvsType) => {
                let objVar: any = {};
                product.variation.forEach((variation) => {
                  objVar[variation.grid] = variation.value;
                });
                return {
                  id: product.id,
                  name: product.productName,
                  image: product.image,
                  unitPrice: parseFloat((product.unitPrice / 100).toFixed(2)),
                  promotionalPrice: product.price
                    ? parseFloat(
                        ((product.unitPrice - product.discount) / 100).toFixed(
                          2
                        )
                      )
                    : parseFloat(
                        ((product.unitPrice - product.discount) / 100).toFixed(
                          2
                        )
                      ),
                  quantity: product.quantity,
                  stock: product.stock,
                  sku: product.productSku,
                  variation: objVar,
                  code: product.code,
                  locationId: product.locationId,
                  pluginspaceHash: pluginspace_id,
                };
              }
            );
            await orderContext.changeOrderByGuidCart(newProducts, orderContext);
            orderContext.setDiscountGeneral(
              response.data.totalAmountDiscount
                ? response.data.totalAmountDiscount
                : 0
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          return null;
        });
    }
  }

  //Pesquisar o cep digitado e repassar para a função de salvar endereço do cliente no localStorage
  async function findCepAdress(cep2: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep2.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          return false;
        } else {
          return true;
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "warning",
          title: "CEP inválido!",
          text: "Verifique se o CEP foi digitado corretamente.",
        });
        return false;
      });
  }

  async function getVerifyShift() {
    try {
      const pgData = await getThisPluginspace();
      const response = await api.post(
        `api/location-operation/verify`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );
      if (pgData && pgData.type === "food") {
        setValidShift(response.data && response.data.success);
      } else {
        setValidShift(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  //Utilização do login:

  const loadAddresses = async () => {
    if (loginInfo.identifier) {
      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: loginInfo.identifier,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response: any) => {
          if (response.data.data.length > 0) {
            const data = response.data.data[0];
            setCustomerName(data.name);

            const customer: CustomerType = {
              id: data.id,
              name: data.name,
              email: data.email,
              cpf: data.doc,
              birthdate: data.birthDate,
              wppNotification: data.optinWhatsapp,
              acceptTermDate: data.lgpdDataAceiteCarta,
              gender: data.gender,
              telephone: data.customerPhones[0]?.numberPhone
                ? data.customerPhones[0]?.numberPhone
                : "",
              cep: data.customerAddresses[0]?.zipCode
                ? data.customerAddresses[0]?.zipCode
                : "",
              address: data.customerAddresses[0]?.street
                ? data.customerAddresses[0]?.street
                : "",
              district: data.customerAddresses[0]?.district
                ? data.customerAddresses[0]?.district
                : "",
              city: data.customerAddresses[0]?.city
                ? data.customerAddresses[0]?.city
                : "",
              state: data.customerAddresses[0]?.state
                ? data.customerAddresses[0]?.state
                : "",
              number: data.customerAddresses[0]?.number
                ? data.customerAddresses[0]?.number
                : "",
              complement: data.customerAddresses[0]?.extra
                ? data.customerAddresses[0]?.extra
                : "",
              ibge: data.customerAddresses[0]?.ibgeCode
                ? data.customerAddresses[0]?.ibgeCode
                : "",
              inscEstadual: data.inscEstadual,
            };
            if (data && data.customerId) {
              customer.customerWinthor = data.customerId;
            }
            setCustomer(customer);
            setAddresses(data.customerAddresses);
            setAddress(data.customerAddresses[0]);
            loadStorebyCustomerCEP(data.customerAddresses[0].zipCode);
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  };

  const loadStorebyCustomerCEP = async (cep: string) => {
    const orderSave = await orderContext.getOrder();
    const skus: Array<String> | undefined = orderSave.products.map(
      (prod) => prod.sku
    );
    if (!skus || skus.length === 0) {
      return;
    }

    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      setLoading(false);
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue
        )}`,
      });
      return;
    }

    const pgData = await getThisPluginspace();

    await api
      .post(
        `/api/variations/skuzipcode`,
        {
          zipcode: cep,
          skus: skus ? skus : [],
          restrictCep: config?.content.pdv.restrictCep
            ? config?.content.pdv.restrictCep
            : "cep",
          noVerifyStock:
            (pgData && (pgData.type === "food" || pgData.type === "retail")) ||
            (config && config.content.pdv.showOutStock)
              ? true
              : false,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        let newStores: Array<StoresType> = [];

        if (!response.data || response.data.success === false) {
          //Fazer um for para mostrar todos os produtos e mostrar na tela
          if (response.data.dataEmpty) {
            const ids = response.data.dataEmpty.map((prod: any) => prod.sku);
            const filtered = response.data.dataEmpty.filter(
              (prod: any, index: number) => !ids.includes(prod.sku, index + 1)
            );

            Swal.fire({
              icon: "warning",
              title: response.data.message
                ? response.data.message
                : "CEP indisponível!",
              text:
                response.data.dataEmpty && response.data.dataEmpty.length > 0
                  ? `Produtos: ${filtered
                      .map((u: any) => u.name)
                      .join(", ")} sem estoque`
                  : "",
            });
          } else {
            const filtered: any = [];
            Swal.fire({
              icon: "warning",
              title: response.data.message
                ? response.data.message
                : "CEP indisponível!",
              text:
                response.data.dataEmpty && response.data.dataEmpty.length > 0
                  ? `Produtos: ${filtered
                      .map((u: any) => u.name)
                      .join(", ")} sem estoque`
                  : "Produtos não disponiveis!",
            });
          }

          setCanWithdraw(false);
          setStores([]);
          setFindCep(false);
          return;
        }
        //Fazer validação dos produtos desativados no retorno ;

        // comparar sku enviado com os retornados.
        const ids = response.data.map((prod: any) => prod.sku);
        const filtered = response.data.filter(
          (prod: any, index: number) => !ids.includes(prod.sku, index + 1)
        );
        let doesNotexists = skus.map((skus: any) => {
          const find = filtered.find((prod: any) => prod.sku === skus);

          if (!find) {
            return skus;
          }
        });

        doesNotexists = doesNotexists.filter((skus: any) => skus !== undefined);

        if (doesNotexists.length > 0) {
          const produtos = doesNotexists.map((skus: any) => {
            const find = orderSave.products.find(
              (prod: any) => prod.sku === skus
            );

            return find!.name;
          });

          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: response.data.message
              ? response.data.message
              : "Produtos Indisponiveis!",
            text: `Produtos: ${produtos
              .map((u: any) => u)
              .join(", ")} não disponiveis`,
          });
          setCanWithdraw(false);
          setStores([]);
          setFindCep(false);
          return;
        }

        setProductStores(response.data);
        response.data.map((str: StoresType) => {
          const newStore = {
            id: str.id,
            name: str.name,
            city: str.city,
            district: str.district,
            street: str.street,
            number: str.number,
            distance: str.distance,
            currentBalance: str.currentBalance,
          };
          const findedStore = newStores.find(
            (findStore) =>
              findStore.name === newStore.name &&
              findStore.distance === newStore.distance
          );
          if (!findedStore) {
            newStores.push(newStore);
          }
        });
        setCanWithdraw(true);
        await findCepAdress(cep);
        await findCepDeliveryCustomerCep(cep);

        setStores(newStores);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        Swal.fire({
          icon: "warning",
          title: "Erro!",
          text: "Falha ao buscar CEP",
        });
      });
  };

  async function findCepDeliveryCustomerCep(cep: string) {
    if (config) {
      const value = config!.content.pdv.withDrawFee
        ? parseFloat(config!.content.pdv.withDrawFee.toString())
        : 0;

      setValueWithDraw(value);
      setFreightFind(value);
    }

    let urlSearchValid = "";
    switch (config?.content.pdv.restrictCep) {
      case "cep":
        urlSearchValid = `/api/zip-code/valid/${cep}`;
        break;
      case "area":
        urlSearchValid = `/api/delivery/valid/${cep}`;
        break;
      case "mapa":
        urlSearchValid = `/api/delivery-area/valid/${cep}`;
        break;
      default:
        urlSearchValid = `/api/zip-code/valid/${cep}`;
        break;
    }
    setLoading(true);
    await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        setLoading(false);
        const findedCeps = response.data.data;
        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);

          setValueCep(findedCeps[0].valor);
        } else {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Não foi possível encontrar formas de envio para o CEP",
          });

          setFindCep(false);
          setCanWithdraw(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setFindCep(false);
        setCanWithdraw(false);
        console.log(err);
      });
  }

  async function findLocationId() {
    await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: LocationResponseType) => location.code == "delivery"
        );
        setLocationId(location.id);
        navigate(`/${pluginspace_id}/order`);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao encontrar loja",
        });
      });
  }

  async function orderWithDraw() {
    setType("withdraw");
    await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const loc = response.data.data.find(
          (location: LocationResponseType) => location.type == "address"
        );
        const locationWithdraw = response.data.data.find(
          (location: LocationResponseType) => location.code == "withdraw"
        );
        setOrderAddress({
          address: loc.address.street,
          cep: loc.cep,
          state: loc.address.state,
          city: loc.address.city,
          complement: loc.address.extra,
          district: loc.address.district,
          name: stores[0]?.name,
          number: loc.address.number,
          reference: "",
          otherPersonToWithdrawal: null,
        });
        setLocationId(locationWithdraw.id);

        navigate(`/${pluginspace_id}/order`);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao encontrar loja",
        });
      });
  }

  async function orderDelivery() {
    const addDelivery: DeliveryAddressType = {
      zipcode: address.zipCode,
      extra: address.complement,
      reference: "",
      name: customerName,
      phone: customerPhone,
      street: address.street,
      district: address.district,
      city: address.city,
      state: address.state,
      number: address.number,
    };

    changeAddressDelivery(addDelivery);
    setLoading(true);
    const noMaskCep = cepNoMask(address.zipCode);
    const order = await orderContext.getOrder();
    const skus: Array<String> | undefined = order.products.map(
      (prod) => prod.sku
    );
    const config = await getAppConfig();
    const pgData = await getThisPluginspace();

    await api
      .post(
        `/api/variations/skuzipcode`,
        {
          zipcode: noMaskCep,
          skus: skus ? skus : [],
          restrictCep: config?.content.pdv.restrictCep
            ? config?.content.pdv.restrictCep
            : "cep",
          noVerifyStock:
            (pgData && (pgData.type === "food" || pgData.type === "retail")) ||
            (config && config.content.pdv.showOutStock)
              ? true
              : false,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.length > 0) {
          setType("delivery");
          const newTelephone = telephoneNoMask(customerPhone);
          setOrderAddress({
            address: address.street,
            cep: address.zipCode,
            city: address.city,
            complement: "",
            district: address.district,
            customerName,
            number: address.number,
            reference: "",
            telephone: newTelephone,
            state: address.state,
            ibge: address.ibgeCode,
          });
          await findLocationId();
          navigate(`/${pluginspace_id}/order`);
        } else {
          Swal.fire({
            icon: "warning",
            title: "CEP Indisponível",
            text: "Este CEP não faz parte dessa área de entrega",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  // procurar endereço de acordo com informado no campo CEP

  async function searchCep() {
    if (cep) {
      setLoading(true);
      return await api
        .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
        .then((response) => {
          if (response.data.erro) {
            Swal.fire({
              icon: "warning",
              title: "CEP inválido!",
              text: "Verifique se o CEP foi digitado corretamente.",
            });
            return false;
          } else {
            setLoading(false);
            return true;
          }
        })
        .catch(() => {
          setLoading(false);

          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          return false;
        });
    } else {
      return false;
    }
  }

  useEffect(() => {
    registerAccess("cart");
    loadAll();
  }, []);

  useEffect(() => {
    loadAll();
  }, [loginInfo]);

  useEffect(() => {
    loadOrder();
  }, [orderContext]);

  return (
    <div className="newCart">
      <div className="content-newCart">
        <Header
          background={
            config?.webappcolor.backgroundheader
              ? config?.webappcolor.backgroundheader
              : "#F5F5F5"
          }
          colorIcon={
            config?.webappcolor.iconsheader
              ? config.webappcolor.iconsheader
              : "#636363"
          }
          logo={config?.icon ? config.icon : ""}
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
        <div className="content-newCart">
          {loading ? (
            <div
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <Loading
                type="spinningBubbles"
                color="#FFF"
                width={64}
                height={64}
              />
            </div>
          ) : (
            <div className="content-newCart-main-values">
              <div className="ProductsContent">
                <div className="headerProduct">
                  <h4>Carrinho de compras</h4>
                </div>
                <div className="ListProduct">
                  {order &&
                    order.products.map((prod) => (
                      <NewCartItem
                        typePluginspace={typePluginspace}
                        product={prod}
                        key={prod.id}
                        showOutStock={config?.content.pdv.showOutStock}
                        motorTotvs={totvsMotorAble}
                      />
                    ))}
                </div>
              </div>

              {login ? (
                <>
                  <div className="zipcode">
                    <div className="zipcode-options">
                      <div className="zipcode-option-Login">
                        <div className="zipcode-option">
                          <input
                            type="radio"
                            value={typeFreight}
                            onChange={() => {
                              setTypeFreight("delivery");

                              setFreightFind(valueCep);
                            }}
                            checked={typeFreight === "delivery"}
                          />{" "}
                          <label className="labelCep">
                            <span> Receber no CEP cadastrado: </span>
                            <span>{floatToPrice(valueCep)}</span>
                          </label>
                        </div>

                        {address && (
                          <div className="zipcode-option-CustomerLocation">
                            <div className="zipcode-option-CustomerLocation-Info">
                              <span>{customerName}</span>
                              <span>
                                {address.district},{address.street},
                                {address.number}
                              </span>

                              {address.complement && (
                                <span>{address.complement}</span>
                              )}
                              <span>
                                {address.city},{address.state},
                                {cepToMask(address.zipCode)}
                              </span>
                            </div>
                            <div className="zipcode-option-CustomerLocation-Options">
                              <span
                                className="optionText"
                                onClick={() => setSelectAddressOpen(true)}
                              >
                                {" "}
                                <BiRefresh className="IconSize" /> Usar outro
                                endereço cadastrado
                              </span>

                              <span
                                className="optionText"
                                onClick={() => setCreateAddressOpen(true)}
                              >
                                <BiPlusCircle className="IconSize" /> Cadastrar
                                um novo endereço
                              </span>

                              {cep && canWithdraw && (
                                <span
                                  className="optionText"
                                  onClick={() => setCreateAddressOpen(true)}
                                >
                                  <BiPlusCircle className="IconSize" />{" "}
                                  Cadastrar endereço pesquisado
                                </span>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="zipcode-option">
                        <input
                          type="radio"
                          value={typeFreight}
                          checked={typeFreight === "withdraw"}
                          onChange={() => {
                            setTypeFreight("withdraw");
                            setFreightFind(valueWithDraw);
                          }}
                        />{" "}
                        <label>
                          Retirar na loja: {floatToPrice(valueWithDraw)}
                        </label>
                      </div>
                    </div>
                    <div className="zipcode-input">
                      <div className="inputZipcode">
                        <div className="inputTextCEP">
                          <InputMask
                            mask="99999-999"
                            className=""
                            type="text"
                            value={cep}
                            onFocus={() => setHideMenu(true)}
                            onBlur={() => {
                              setHideMenu(false);
                            }}
                            onChange={(value) => {
                              setCep(value.target.value);
                              setFindCep(false);
                              setCanWithdraw(false);
                            }}
                            placeholder="00000-000"
                          />
                        </div>
                      </div>

                      <button
                        onClick={() => {
                          getStores();
                          searchCep();
                        }}
                      >
                        Calcular
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="zipcode">
                    <div className="zipcode-info">
                      <span>
                        Informe o seu CEP para validar as opções de entrega ou
                        retirada.
                      </span>
                    </div>

                    <div className="zipcode-input">
                      <div className="inputZipcode">
                        <div className="inputTextCEP">
                          <InputMask
                            mask="99999-999"
                            className=""
                            type="text"
                            value={cep}
                            onFocus={() => setHideMenu(true)}
                            onBlur={() => {
                              setHideMenu(false);
                            }}
                            onChange={(value) => {
                              setCep(value.target.value);
                              setFindCep(false);
                              setCanWithdraw(false);
                            }}
                            placeholder="00000-000"
                          />
                        </div>
                      </div>

                      <button
                        onClick={() => {
                          getStores();
                          searchCep();
                        }}
                      >
                        Calcular
                      </button>
                    </div>

                    <div className="zipcode-options">
                      <div className="zipcode-option">
                        <input
                          type="radio"
                          value={typeFreight}
                          onChange={() => {
                            setTypeFreight("delivery");

                            setFreightFind(valueCep);
                          }}
                          checked={typeFreight === "delivery"}
                        />{" "}
                        <label className="labelCep">
                          <span>Receber no CEP informado: </span>
                          <span>{floatToPrice(valueCep)}</span>
                        </label>
                      </div>
                      <div className="zipcode-option">
                        <input
                          type="radio"
                          value={typeFreight}
                          checked={typeFreight === "withdraw"}
                          onChange={() => {
                            setTypeFreight("withdraw");
                            setFreightFind(valueWithDraw);
                          }}
                        />{" "}
                        <label className="labelCep">
                          <span>Retirar na loja:</span>
                          <span>{floatToPrice(valueWithDraw)}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div
                className="orderResume"
                style={{
                  color: config?.webappcolor.fontinfocart
                    ? config.webappcolor.fontinfocart
                    : "#636363",
                }}
              >
                <h1>Resumo da Compra</h1>
                <div className="item-resume">
                  <p>Valor dos Produtos</p>
                  <p>{floatToPrice(totalWithoutDiscount)}</p>
                </div>
                <div className="item-resume">
                  <p>Desconto</p>
                  <p>{floatToPrice(totalWithoutDiscount - total)}</p>
                </div>
                <div className="item-resume">
                  <p>Taxa de entrega</p>
                  <p>{floatToPrice(freightFind)}</p>
                </div>
                <div className="item-total-resume">
                  <p>Total da compra</p>
                  <p>{floatToPrice(total + freightFind)}</p>
                </div>
              </div>

              {totvsVarejoAble && totvsMotorAble && (
                <div className="coupom">
                  <input
                    type="text"
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                    placeholder="Adicione um cupom de desconto"
                  />
                  <svg
                    onClick={async () => await calculateDiscount()}
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox=" -8  -8 40 40"
                    fill="none"
                  >
                    <ellipse cx="12" cy="12" rx="20" ry="20" fill="#37393D" />

                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.1064 6L12.0335 7.05L16.3253 11.25H6.97522V12.75H16.3253L12.0335 16.95L13.1064 18L19.2376 12L13.1064 6Z"
                      fill="white"
                    />
                  </svg>
                </div>
              )}
              <div className="finishOrder">
                <button
                  className="finishOrderButton"
                  onClick={async () => {
                    if (login) {
                      if (validShift) {
                        setLoading(true);
                        await calculateDiscount();
                        await chooseAddress();
                        setLoading(false);
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "Atenção!",
                          text: `A loja se encontra fechada e não está aceitando pedidos`,
                        });
                      }
                    } else {
                      Swal.fire({
                        icon: "warning",
                        title: "Atenção!",
                        text: `Realize o login ou cadastre-se para continuar com a compra`,
                        confirmButtonText: "Login",
                        showCancelButton: true,
                        cancelButtonText: "OK",
                      }).then((result) => {
                        if (result.isConfirmed)
                          navigate(`/${pluginspace_id}/auth`);
                      });
                    }
                  }}
                >
                  <span>Finalizar Compra</span>
                </button>
              </div>
            </div>
          )}
        </div>
        <Menu
          activeMenu="cart"
          fontColor={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          activeFontColor={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#000"
          }
          backgroundMenu={
            config?.webappcolor.backgroundfooter
              ? config?.webappcolor.backgroundfooter
              : "#F5F5F5"
          }
          colorIcons={
            config?.webappcolor.iconsfooter
              ? config?.webappcolor.iconsfooter
              : "#636363"
          }
          highlightColorIcons={
            config?.webappcolor.highlightfooter
              ? config?.webappcolor.highlightfooter
              : "#636363"
          }
          hide={hideMenu}
          backgroundCart={
            config?.webappcolor.backgroundcart
              ? config.webappcolor.backgroundcart
              : "#FFBA49"
          }
          fontCart={
            config?.webappcolor.fontcart ? config.webappcolor.fontcart : "#000"
          }
          noSales={
            config &&
            config?.content &&
            config?.content.pdv &&
            config?.content.pdv.noSales
              ? config.content.pdv.noSales
              : false
          }
        />
      </div>
      <ModalCreateAddress
        isOpen={createAddressOpen}
        setIsOpen={setCreateAddressOpen}
        setAddressOrder={setAddress}
        verifyAddress={findCepDeliveryCustomerCep}
        searchCep={cep}
      />
      <ModalSelectAddress
        isOpen={selectAddressOpen}
        setIsOpen={setSelectAddressOpen}
        addresses={addresses}
        setAddress={setAddress}
        verifyAddress={findCepDeliveryCustomerCep}
      />
    </div>
  );
};

export { NewCartLogin };
